import utils from './utilities';
import listingUtils from './listingUtilities';
import reportUtils from './reportUtilities';
import { TENANT_KEY } from '../../../utility/env';

const bayutUtilities = Object.freeze({ key: TENANT_KEY, ...utils, ...listingUtils, ...reportUtils });

export default bayutUtilities;
